import { Helmet } from 'react-helmet';

const Verify = () => {
  return (
    <>
      <Helmet>
        <title>Verify Certificate | Shrikant Tally Institute – Damoh</title>
        <meta name="description" content="Verify your Tally certification issued by Shrikant Tally Institute, Damoh. Validate your Tally Education certificate online instantly." />
        <meta name="keywords" content="verify Tally certificate, Tally certificate verification, Shrikant Tally certificate, Tally Education certificate verify, accounting certificate Damoh, Tally certification check, validate Tally certificate online" />
        <meta property="og:title" content="Verify Your Tally Certificate | Shrikant Tally Institute" />
        <meta property="og:description" content="Instantly verify your Tally certification from Shrikant Tally Institute, Damoh. Showcase your accredited skills to employers." />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/verify" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://shrikanttallyinstitute.com/verify" />
      </Helmet>
<div className="col-md-12 col-sm-12 p-2 p-md-5 banner-height">
  <div className="container">
    <div className="row align-items-center">

      {/* Image for small screens */}
      <div className="col-md-5 d-block d-md-none text-center">
        <img 
          src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/certificate-banner.png" 
          alt="About Us" 
          className="w-100" 
        />
      </div>

      {/* Certificate verification content */}
      <div className="col-md-7 d-flex flex-column justify-content-center align-items-center p-2 my-4">
        <div className="inside-banner-content text-center">
          <h1 className="mb-2 mb-md-5 text-start" style={{ color: "#90b732" }}>
            Verify Your Certificate
          </h1>
          <p className="mb-5 text-start">
            Validate your expertise with confidence! Verify your Tally certification now and
            showcase your accredited skills to potential employers.
          </p>

          <div className="w-100 d-flex justify-content-center">
            <div className="input-group">
              <input 
                type="text" 
                id="CertificateNumber" 
                className="form-control input-field c-field" 
                placeholder="Enter Certificate Number" 
                style={{ maxWidth: "300px", height: "50px" }} 
                required 
              />
              <input 
                type="hidden" 
                id="encodeCertificate" 
                name="encodeCertificate" 
                value="0" 
              />
              <button 
                id="verifyCertificateBtn" 
                className="btn text-white fw-bold" 
                style={{ height: "50px", width: "180px", background:'#90b732'}}
              >
                Verify Certificate
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Image for medium and larger screens */}
      <div className="col-md-5 d-none d-md-block text-center">
        <img 
          src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/certificate-banner.png" 
          alt="About Us" 
          className="w-100" 
        />
      </div>

    </div>
  </div>
</div>
<section className="out-story-section" id="sampleCertificate">
  <div className="container mb-4">
    <div className="row">

      <div className="text-center">
        <h2 className="heading2">
          Sample Certificate
        </h2>
      </div>

      <div className="text-center mt-5">
        <img 
          src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/certificate.jpg" 
          alt="Sample Certificate" 
          className="w-50" 
        />
        <iframe 
          src="" 
          id="contentFrame" 
          className="d-none" 
          style={{ width: "100%", height: "98vh" }}
        />
      </div>
    </div>
  </div>
</section>

</>
  );
};

export default Verify;
